import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="mx-auto max-w-[720px] px-5 pb-20 pt-8 sm:px-6 md:px-8" data-id="element-75" data-mp="1l9o6t8rmrzlq">
      <SectionHeading data-id="element-76" data-mp="1ge8wurwqunul">Frequently asked questions</SectionHeading>

      <ul className="mt-8 divide-y divide-cream-300 overflow-hidden rounded-2xl border border-cream-300 bg-white" data-id="element-77" data-mp="2e0pphjuj8da0">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <li key={faq.question} data-id="element-78" data-mp="240yu7fy5du8v" data-mpi={index}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center gap-4 px-5 py-4 text-left" data-id="element-79" data-mp="24436z1pohyb5">
                <span className="flex-1 text-[16px] font-medium text-ink-900" data-id="element-80" data-mp="nmyvg8b1gan7">{faq.question}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-ink-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-81" data-mp="pizf3w92p2fb" />
              </button>
              {isOpen ? <p className="px-5 pb-5 text-[15.5px] leading-[1.65] text-ink-500" data-id="element-82" data-mp="ki1uld0lbwan">{faq.answer}</p> : null}
            </li>;
      })}
      </ul>
    </section>;
}